import { useEffect, useState } from 'react'
import { styled, keyframes } from 'styled-components'

const PIECE_COUNT = 80;
const COLORS = ['#34b076', '#f9c74f', '#f3722c', '#577bc1', '#e04f4f', '#9b5de5'];
const LIFETIME_MS = 4500;

const fall = keyframes`
  0% {
    opacity: 1;
    transform: translate3d(0, 0, 0) rotate(0deg);
  }
  85% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translate3d(var(--drift), 85vh, 0) rotate(var(--spin));
  }
`

const ConfettiLayer = styled.div`
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 1;

  @media (prefers-reduced-motion: reduce) {
    display: none;
  }
`

const Piece = styled.span`
  position: absolute;
  top: -20px;
  display: block;
  animation: ${fall} var(--duration) cubic-bezier(0.25, 0.6, 0.45, 1) var(--delay) forwards;
  opacity: 0;
`

const randomBetween = (min: number, max: number) => min + Math.random() * (max - min);

const createPieces = () => Array.from({ length: PIECE_COUNT }, (_, i) => ({
	id: i,
	left: randomBetween(0, 100),
	width: randomBetween(6, 10),
	height: randomBetween(8, 16),
	color: COLORS[i % COLORS.length],
	round: Math.random() < 0.3,
	delay: randomBetween(0, 0.6),
	duration: randomBetween(2.2, 3.6),
	drift: randomBetween(-80, 80),
	spin: randomBetween(-720, 720),
}));

export default function Confetti() {
	const [pieces] = useState(createPieces);
	const [visible, setVisible] = useState(true);

	useEffect(() => {
		const timeout = setTimeout(() => setVisible(false), LIFETIME_MS);
		return () => clearTimeout(timeout);
	}, [])

	if (!visible) return null;

	return (
		<ConfettiLayer aria-hidden="true">
			{pieces.map((piece) => (
				<Piece
					key={piece.id}
					style={{
						left: `${piece.left}%`,
						width: piece.width,
						height: piece.round ? piece.width : piece.height,
						borderRadius: piece.round ? '50%' : '2px',
						backgroundColor: piece.color,
						'--delay': `${piece.delay}s`,
						'--duration': `${piece.duration}s`,
						'--drift': `${piece.drift}px`,
						'--spin': `${piece.spin}deg`,
					} as React.CSSProperties}
				/>
			))}
		</ConfettiLayer>
	)
}
